import OtpInput from 'react-otp-input';
import React, { useRef, useState } from 'react';
import './Verifycode.css';
import { useNavigate, Link } from 'react-router-dom';
import StyledButton from '../../../components/Button/Button';
import Popup from '../../../components/Inputs/Popup';
import { Box, Typography, FormControl, CircularProgress } from '@mui/material';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import { forgotPassword, verifyCode } from '../../../services/NetworkServices';
import { getEmail, getRole } from '../../../utils/auth-token-utils/cookie';
import ApiStatus from '../../../config/apiStatusConstants';
import { VerifyCodeResponse } from '../../../services/types/APIResponseType';
import { storeOTPVerificationToken } from '../../../utils/auth-token-utils/cookie';

const Verifycode: React.FC = () => {
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.INITIAL);
  const [otp, setOtp] = useState<string>('');
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isResent, setIsResent] = useState<boolean>(false);
  const [seconds, setSeconds] = useState<number>(0);
  const [minutes, setMinutes] = useState<number>(2);
  const [elapsedTime, setElapsedTime] = useState<number>(0);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const role = getRole();
  const email = getEmail();

  const navigate = useNavigate();

  const handleResend = async () => {
    setSeconds(0);
    setMinutes(2);
    setElapsedTime(0);
    setIsResent(true);
    const response = await forgotPassword({
      email: email ?? '',
      role: role ?? '',
    });

    let currentMinutes = 2;
    let currentSeconds = 0;

    const intervalId = setInterval(() => {
      if (currentSeconds === 0) {
        if (currentMinutes === 0) {
          clearInterval(intervalId);
          setIsResent(false);
          return;
        }
        currentMinutes -= 1;
        currentSeconds = 59;
      } else {
        currentSeconds -= 1;
      }
      setMinutes(currentMinutes);
      setSeconds(currentSeconds);
    }, 1000);
  };

  const handleCodeVerification = async () => {
    setApiStatus(ApiStatus.LOADING);
    try {
      const response = await verifyCode({ email: email ?? '', otp: otp ?? '' });
      console.log('response is', response);
      const data: VerifyCodeResponse = await response.data;
      if (data) {
        setApiStatus(ApiStatus.SUCCESS);
        storeOTPVerificationToken(data.data.token);
        setShowPopup(true);
      }
    } catch (error: any) {
      setApiStatus(ApiStatus.FAILURE);
      console.log('error is ', error);
      setErrorMsg(
        error.response.data.message ||
          'Something went wrong. Please try again.',
      );
    }
  };

  const handleContinue = () => {
    navigate('/changepassword');
  };

  const renderButton = () => {
    if (apiStatus === ApiStatus.LOADING) {
      return (
        <StyledButton>
          <CircularProgress size={20} />
        </StyledButton>
      );
    } else {
      return (
        <StyledButton onClick={handleCodeVerification} disabled={!otp}>
          Verify Code
        </StyledButton>
      );
    }
  };

  const renderErrorMsg = () => {
    if (apiStatus === ApiStatus.FAILURE) {
      return <p className="error1-msg">{errorMsg}</p>;
    }
    return null;
  };

  return (
    <>
      {showPopup && <div className="backdrop"></div>} {/* Overlay backdrop */}
      <StyledBgContainer className={showPopup ? 'popup-active' : ''}>
        <TopNav showArrow={true} backRoute={'/signin'} />
        <Box className="bg-box">
          <form>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                px: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontFamily: 'Opensans',
                  fontWeight: '700',
                }}
              >
                Verify Code
              </Typography>
              <Typography variant="body2" sx={{ color: 'grey', mt: 1, mb: 3 }}>
                We sent required otp to your email
              </Typography>
              <FormControl
                fullWidth
                variant="outlined"
                sx={{
                  mb: 2,
                  alignItems: 'center',
                }}
              >
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={4}
                  inputStyle={{
                    width: '5vw',
                    margin: '0 10px',
                    borderColor: '#365f91',
                    background:
                      'linear-gradient(black,black) padding-box, linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box',
                    border: '1.4px solid transparent',
                    height: '12vh',

                    borderRadius: '21px',
                    color: 'white',
                  }}
                  // renderSeparator={<span>   </span>}
                  renderInput={(props) => <input {...props} />}
                />
              </FormControl>
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                {renderErrorMsg()}
              </Box>

              {isResent ? (
                <p className="resend-text">
                  Resend Code in{' '}
                  <span className="resend-timer">
                    {String(minutes).padStart(2, '0')}:
                    {String(seconds).padStart(2, '0')}
                  </span>
                </p>
              ) : (
                <Box sx={{ marginBottom: '20vh', marginTop: '5px' }}>
                  <Typography variant="body2" sx={{ color: 'grey', mt: 3 }}>
                    Didn't Receive Code ?
                  </Typography>

                  <Typography
                    onClick={handleResend}
                    className="linkStyle"
                    sx={{ mt: 1, fontWeight: '600', fontFamily: 'Opensans' }}
                  >
                    Resend
                  </Typography>
                </Box>
              )}
            </Box>
          </form>
          <Box sx={{ mt: 3 }}> {renderButton()} </Box>
          <Box sx={{ mt: 3 }}>
            <Typography sx={{ color: 'grey', mt: 3, mb: 5 }}>
              Back to{' '}
              <Link className="linkstyle" to="/signin">
                Sign In{' '}
              </Link>
            </Typography>
            {showPopup && (
              <Popup
                title=<Typography
                  variant="h6"
                  sx={{
                    fontFamily: 'opensans',
                    fontWeight: '700',
                    lineHeight: '1.4',
                  }}
                >
                  {' '}
                  Code Verified <br /> Successfully{' '}
                </Typography>
                message=<Typography variant="body2">
                  {' '}
                  The code you entered matches that sent to the email address
                  associated with your account.
                </Typography>
                buttonText="Continue"
                onButtonClick={handleContinue}
              />
            )}
          </Box>
        </Box>
      </StyledBgContainer>
    </>
  );
};

export default Verifycode;
